import React, { useEffect, useState } from 'react';
import { Avatar, Button, Flowbite, Label, TextInput } from 'flowbite-react';
import { BsPhoneFill } from 'react-icons/bs';
import { MdEmail } from 'react-icons/md';
import { AiFillMessage } from 'react-icons/ai';
import { BiCurrentLocation } from 'react-icons/bi';
import { ImLocation2 } from 'react-icons/im';
import RideCard from '../components/RideCard';
import { useNavigate } from 'react-router-dom';
import { Store } from 'react-notifications-component';
import {
  getRideById,
  getUserInfo,
  reserveRide,
} from '../firebase/FirebaseManagement';
import { useParams } from 'react-router-dom';

import { buttonTheme, centerText } from '../components/themes';
import Footer from '../components/Footer';


export default function RexRideCheckout(){
    const navigate  = useNavigate();
    const {rideId} = useParams()
    const [rideDetails, setRideDetails] = useState(null) 
    const [driverInfo, setDriverInfo] = useState(null) 
    const [seats, setSeats] = useState(1)
    
  // get user id from local storage
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const fetchDriverInfo = async () => {
      const driverInfo = await getUserInfo(rideDetails?.driver);
      setDriverInfo(driverInfo);
    };
    fetchDriverInfo();
  }, [rideDetails]);

  useEffect(() => {
    const fetchRideInfo = async () => {
      const rideInfo = await getRideById(rideId);
      setRideDetails(rideInfo);
    };
    fetchRideInfo();
  }, []);

  const handleAddSeats = () => {
    setSeats(seats + 1);
  };

  const handleReduceSeats = () => {
    if (seats > 1) {
      setSeats(seats - 1);
    }
  };

    const handleReserveRide = async () => {
        
         const res = await reserveRide(rideId, userId)
         if (res) {
            Store.addNotification({
                title: "Wonderful!",
                message: "Your seat was reserved successfully!",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    showIcon: true
                  }
              });
              navigate("/myrides")
         }
    }
   

  return (
    <div>
      <div className="md:pt-10 flex flex-col gap-5 md:flex-row">
        {/* Driver's info */}
        <div className="flex md:w-1/3 box-container items-center justify-center">
          <Avatar img={driverInfo?.file} rounded size="xl" />
          <div className="text-center font-bold text-3xl">
            {`${driverInfo?.firstName} ${driverInfo?.lastName}`}
          </div>
          <div className="space-y-1 font-medium dark:text-white">
            <div className="bottom-container flex flex-row gap-32">
              <div className="rideCount">
                <p className="text-lg font-semibold">Rex Rides</p>
                <p className="text-lg font-semibold text-center">10</p>
              </div>
              <div className="rating">
                <p className="text-lg font-semibold">Rating</p>
                <p className="text-lg font-semibold text-center">4.5/5</p>
              </div>
            </div>
          </div>
          {/* Contact info */}
          <div className="flex flex-row flex-wrap gap-0 justify-center items-center">
            <button className="flex flex-row gap-2 items-center p-1 rounded-lg active-text-black">
              <BsPhoneFill />
              {driverInfo?.phoneNumber}
            </button>
            <button className="flex flex-row gap-2 items-center p-1 rounded-lg active-text-black">
              <MdEmail />
              {`${driverInfo?.email}`}
            </button>
            <button className="flex flex-row items-center p-1 rounded-lg">
              {/* <AiFillMessage /> */}
            </button>
          </div>
        </div>

        {/* Contact info and ride details */}
        <div className="md:w-2/3 box-container">
          {/* RexRide Details */}
          <RideCard rideDetails={rideDetails} />

          {/* Seats count buttons */}
          <div>
            <p className="text-center">Seats</p>
            <div className="flex gap-2 justify-center items-center">
              <Flowbite theme={{ theme: buttonTheme }}>
                <Button
                  className="flex flex-row gap-2 border-2 items-center p-1 rounded-lg active-text-white"
                  color="primary"
                  onClick={handleReduceSeats}
                >
                  -
                </Button>
              </Flowbite>
              <Flowbite theme={{ theme: centerText }}>
                <TextInput
                  readOnly
                  id="seats"
                  placeholder={seats}
                  type="text"
                  color="primary"
                  shadow="true"
                />
              </Flowbite>
              <Flowbite theme={{ theme: buttonTheme }}>
                <Button
                  className="flex flex-row gap-2 border-2 items-center p-1 rounded-lg active-text-white"
                  color="primary"
                  onClick={handleAddSeats}
                >
                  +
                </Button>
              </Flowbite>
            </div>
          </div>

          {/* Reserve seats button */}
          <Flowbite theme={{ theme: buttonTheme }}>
            <Button
              color="primary"
              onClick={handleReserveRide}
              className="w-full flex flex-row gap-2 items-center p-1 rounded-lg active-bg-black active-text-white"
              disabled={
                rideDetails?.seats - rideDetails?.passengers.length < seats
              }
            >
              Reserve Seats
            </Button>
          </Flowbite>
        </div>
      </div>
      <Footer />
    </div>
  );
}
